import { createRouter, createWebHashHistory, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '../views/Home.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('../views/Login.vue')
  },
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/TransportationHome.vue')
  },
  {
    path: '/commodity',
    name: 'Commodity',
    component: () => import('../views/CommodityHome.vue')
  },
  {
    path: '/pharmacy',
    name: 'Pharmacy',
    component: () => import('../views/PharmacyHome.vue')
  },
  {
    path: '/medicine',
    name: 'Medicine',
    component: () => import('../views/MedicineHome.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
